<div class="login">

  <!-- Left panel: branding mosaic -->
  <div class="login__panel login__panel--left">
    <app-auth-panel></app-auth-panel>
  </div>

  <!-- Right panel: form -->
  <div class="login__panel login__panel--right">
    @if (challengeToken) {
      <form class="login-form" (ngSubmit)="submitTwoFactorCode()" novalidate>

        <div class="login-form__field">
          <h2 class="login-form__label">Enter your verification code</h2>
          <p class="login-form__hint">
            Enter the 6-digit code from your authenticator app, or one of your backup codes.
            This code expires in {{ challengeExpiresInMinutes }} minutes.
          </p>
        </div>

        <div class="login-form__field">
          <label class="login-form__label" for="two-factor-code">Code</label>
          <div class="login-form__input-wrap">
            <input
              class="login-form__input login-form__input--otp"
              type="text"
              id="two-factor-code"
              autocomplete="one-time-code"
              [ngModel]="twoFactorCode"
              (ngModelChange)="onTwoFactorCodeChange($event)"
              [disabled]="isVerifying"
              name="twoFactorCode"
              placeholder="000000"
            />
          </div>
        </div>

        <div class="login-form__actions">
          <button class="btn btn--primary" type="submit" [disabled]="isVerifying" [attr.aria-busy]="isVerifying">
            @if (isVerifying) {
              <span class="spinner" aria-hidden="true"></span>
              Verifying…
            } @else {
              Verify & sign in
            }
          </button>

          <p class="login-form__footer">
            <button type="button" class="link" (click)="cancelTwoFactorChallenge()">Back to sign in</button>
          </p>
        </div>

      </form>
    } @else {
    <form class="login-form" [formGroup]="form" (ngSubmit)="submit()" novalidate>

      <div class="login-form__field">
        <label class="login-form__label" for="email">Email</label>
        <div class="login-form__input-wrap">
          <input
            class="login-form__input"
            type="email"
            id="email"
            formControlName="email"
            placeholder="name@mila.com"
            autocomplete="email"
          />
        </div>
      </div>

      <div class="login-form__field">
        <label class="login-form__label" for="password">Password</label>
        <div class="login-form__input-wrap">
          <input
            class="login-form__input"
            [type]="showPassword ? 'text' : 'password'"
            id="password"
            formControlName="password"
            placeholder="••••••••"
            autocomplete="current-password"
          />
          <button
            class="login-form__input-icon"
            type="button"
            (click)="togglePasswordVisibility()"
            [attr.aria-pressed]="showPassword"
            [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
          >
            @if (showPassword) {
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.774 3.162 10.066 7.5a10.522 10.522 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
              </svg>
            } @else {
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            }
          </button>
        </div>
      </div>

      <div class="login-form__row">
        <label class="checkbox">
          <input class="checkbox__input" type="checkbox" name="remember" />
          <span class="checkbox__label">Remember me</span>
        </label>
        <a routerLink="/forgot-password" class="link">Forgot password?</a>
      </div>

      <div class="login-form__actions">
        <button class="btn btn--primary" type="submit" [disabled]="isLoading" [attr.aria-busy]="isLoading">
          @if (isLoading) {
            <span class="spinner" aria-hidden="true"></span>
            Signing in…
          } @else {
            Sign in to your account
          }
        </button>

        <p class="auth-form__divider">OR</p>

        <button class="oauth-btn" type="button" (click)="signInWithSso('google')">
          <svg class="oauth-btn__icon" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7955 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z" fill="#4285F4"/>
            <path d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.3441 0-4.3287-1.5831-5.0364-3.7104H.9573v2.3318C2.4382 15.9832 5.4818 18 9 18z" fill="#34A853"/>
            <path d="M3.9636 10.71c-.18-.54-.2827-1.1168-.2827-1.71s.1027-1.17.2827-1.71V4.9582H.9573A8.9965 8.9965 0 000 9c0 1.4523.3477 2.8268.9573 4.0418l3.0063-2.3318z" fill="#FBBC05"/>
            <path d="M9 3.5795c1.3214 0 2.5077.4541 3.4404 1.346l2.5813-2.5814C13.4632.8918 11.4259 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582l3.0063 2.3318C4.6713 5.1626 6.6559 3.5795 9 3.5795z" fill="#EA4335"/>
          </svg>
          Continue with Google
        </button>

        <button class="oauth-btn" type="button" (click)="signInWithSso('microsoft')">
          <svg class="oauth-btn__icon" width="18" height="18" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
            <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
            <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
          </svg>
          Continue with Microsoft
        </button>

        <button class="oauth-btn" type="button" (click)="signInWithSso('cikisi')">
          <img class="oauth-btn__icon" src="/assets/cikisi/c-logo-blue.svg" alt="" aria-hidden="true" />
          Continue with Cikisi
        </button>

        <p class="login-form__footer">
          Don't have an account yet? <a routerLink="/signup" class="link">Sign up</a>
        </p>
      </div>

    </form>
    }
  </div>

</div>
